// Header.jsx
import { FaBars } from "react-icons/fa";
import { useAuthState, useMobileMenuActions } from "@/store";
import { Spacer } from "@/globalStyles";
import { UploadProgress, UserProfile, UploadClips } from "@/components";
import ContributorsSelector from "@/components/Util/ContributorsSelector";
import { HeaderContainer, MobileNavIcon } from "./Header.elements";
import { useIsMobile } from "../hooks";

export const Header = ({ onOpenChangePassword }) => {
    const isMobile = useIsMobile();
    const { setMobileMenuOpen } = useMobileMenuActions();

    const { currentUser } = useAuthState();
    const normalizedRole = (currentUser?.role || "").toLowerCase();

    const isAdmin = normalizedRole === "admin";
    const isManager = normalizedRole === "manager";

    return (
        <HeaderContainer>
            {isMobile && (
                <MobileNavIcon onClick={() => setMobileMenuOpen(true)}>
                    <FaBars />
                </MobileNavIcon>
            )}

            {(isAdmin || isManager) && <ContributorsSelector />}

            <Spacer />

            <UploadClips />
            <UploadProgress />
            <UserProfile onOpenChangePassword={onOpenChangePassword} />
        </HeaderContainer>
    );
};